var map = {
	"./L3-38.png": "45fb",
	"./archeological-dig.png": "cc72",
	"./artist-kit.png": "a471",
	"./back-scratcher.png": "8ba6",
	"./barky-boy.png": "8329",
	"./biscuit-chinois.png": "035b",
	"./black-list.png": "9f4c",
	"./blank-canva.png": "6562",
	"./bubble.png": "b2f3",
	"./chemist-kit.png": "9306",
	"./coconut-cake.png": "0ee9",
	"./commercial-road.png": "819a",
	"./crystal-vase.png": "4eac",
	"./cup-and-ball.png": "b812",
	"./diamant.png": "16e9",
	"./diapason.png": "815c",
	"./dirty-cauldron.png": "a62d",
	"./dwarf.png": "2ae0",
	"./emerald-mine.png": "b30d",
	"./emerald.png": "6ccf",
	"./factory-accident.png": "9acb",
	"./fallen-star.png": "a5f0",
	"./fast-worker.png": "904c",
	"./forgotten-safe.png": "285e",
	"./frog-council.png": "afb6",
	"./gambler-watch.png": "443a",
	"./generous-magpie.png": "2a69",
	"./holy-vaccine.png": "ecb4",
	"./kingofdice.png": "867e",
	"./luckycoin.png": "056a",
	"./magician-trick.png": "ab86",
	"./mariage-shop-card.png": "45b1",
	"./moist-camaleon.png": "aec5",
	"./moon rock.png": "2e1b",
	"./mystery-man.png": "5a2e",
	"./necklace.png": "dcc9",
	"./old-donjon.png": "bcc3",
	"./pieceofgum.png": "ce52",
	"./printer.png": "c34a",
	"./queen.png": "7674",
	"./red-riding-hood.png": "07d2",
	"./restricted-section.png": "61f0",
	"./rich-man-wallet.png": "83bc",
	"./risky-dice.png": "74d6",
	"./scary-night.png": "c4ff",
	"./septre.png": "e106",
	"./soapywater.png": "87b2",
	"./squeleton-blessing.png": "4c1b",
	"./sunny-day.png": "3390",
	"./time-traveler.png": "0bda",
	"./time_machine.png": "059d",
	"./undefinedCard.png": "af8a",
	"./venus-statue.png": "6a6d",
	"./werewolf.png": "1979",
	"./xray-glasses.png": "7e19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d96b";